import Button from "@/components/common/form/button";
import { IoMdAdd } from "react-icons/io";
import { setNotAuthorizedAlertData } from "@/redux/actions/notAuthorizedAlert";
import { useDispatch } from "react-redux";
import { authServices } from "services/auth.services";

export default function ActionButtonsFertigators(props) {
  const dispatch = useDispatch();

  const { showModalFertigators, setShowModalFertigators, label } = props;
  return (
    <div className="relative flex items-center justify-end w-full mb-2 gap-x-2">
      <Button
        title={label}
        className="flex items-center justify-center px-3 py-1 text-white rounded-md bg-main "
        click={() =>
          authServices.userValue.policy_data.asset.actions.includes?.("create")
            ? setShowModalFertigators(!showModalFertigators)
            : dispatch(
                setNotAuthorizedAlertData({ key: "showModal", value: true })
              )
        }
        icon={() => <IoMdAdd size="1.1rem" />}
      />
    </div>
  );
}
